import { Component, OnInit , ChangeDetectionStrategy } from '@angular/core';
import { GmsmenuService } from '../core/services/gmsmenu.service';

@Component({
    selector: 'app-gms-nav-menu',
    templateUrl: './gms-nav-menu.component.html',
    styleUrls: ['./gms-nav-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GmsNavMenuComponent implements OnInit {
  public navlinksData: any;
  constructor(private gmsMenuSer: GmsmenuService) {
    this.navlinksData = this.gmsMenuSer.gmsMenuData;
    console.log(this.navlinksData);
  }

  ngOnInit(): void {
  }
  getMenusData() {
    return Object.keys(this.navlinksData);
  }
}
